import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowForward, IoMdAdd } from "react-icons/io";
import "react-datepicker/dist/react-datepicker.css";
import { IoAdd, IoCalendarClearOutline, IoClose } from "react-icons/io5";
import {
  FaTasks,
  FaCheckCircle,
  FaPause,
  FaRegCheckCircle,
  FaCalendarAlt,
  FaAngleLeft,
  FaAngleRight,
  FaUserCircle,
} from "react-icons/fa";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { fetchApi } from "../../../utlis/axios";
import DropZone from "./DropZone";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Loader from "../../Loader/Loader";
import { FcCancel } from "react-icons/fc";
import TicketModal from "./TicketModal";
import Calendar from "./Calendar";
import RichTextEditor1 from "./RichTextEditor1";
import { addToast } from "../../../Redux/Slices/toast-slice";
import { motion } from "framer-motion";
import { PiKanban } from "react-icons/pi";
import { MdOutlineViewList, MdPreview } from "react-icons/md";
import { BsGrid3X3Gap, BsThreeDotsVertical } from "react-icons/bs";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin6Line, RiEdit2Fill, RiTaskFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { BiSolidDollarCircle } from "react-icons/bi";
import ViewProject from "./popupsComponent/ViewProject";
import ProjectDetail from "./ProjectDetail";
import { FaClipboardList } from "react-icons/fa6";
import loader from "../../../assets/loading-gif.gif";
import TicketView from "./popupsComponent/TicketView";
import MilestoneView from "./popupsComponent/MilestoneView";

const Board = () => {
  const { theme } = useSelector((state) => state.theme);
  const { userInfo } = useSelector((state) => state?.auth || {});
  const navigate = useNavigate();
  const [isModalOpen, setShowModal] = useState(false);
  const [ticketModal, setTicketModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState("in-progress");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [creating, setCreating] = useState(false);
  const [columTitle, setColumTitle] = useState(null);
  const [columnModal, setColumnModal] = useState(false);
  const [isEditingColumn, setIsEditingColumn] = useState(false);
  const [editingColumnId, setEditingColumnId] = useState(null);
  const [columns, setColumns] = useState([
    /*{ company: userInfo?.company?.id, id: "1", title: "todo" },
    { company: userInfo?.company?.id, id: "2", title: "ready for qa" },
    { company: userInfo?.company?.id, id: "3", title: "done" },*/
  ]);
  const [projectSideBarOpen, setProjectSideBarOpen] = useState(true);

  const [newTicketColumnId, setNewTocketColumnId] = useState(null);
  const [projectData, setProjectData] = useState({
    title: "",
    description: "",
    startDate: "",
    endDate: "",
    url: "",
    budget: "",
  });
  const [startDateDropdown, setStartDateDropdown] = useState(false);
  const [endDateDropdown, setEndDateDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ticketsLoading, setTicketsLoading] = useState(true);
  const [firstProjectId, setFirstProjectId] = useState(
    localStorage.getItem("firstProjectId")
  );
  const [selected, setSelected] = useState("kanban");
  const [projects, setProjects] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [loadingTickets, setLoadingTickets] = useState([]);
  const dispatch = useDispatch();
  const [openedProject, setOpenedProject] = useState("");
  const [newTicketStatus, setNewTicketStatus] = useState("todo");
  const [draggingColumn, setDraggingColumn] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [openedId, setOpenedId] = useState(null);
  const popUpRef = useRef();
  const dispatach = useDispatch();
  const columnModalRef = useRef();
  const [isEditing, setIsEditing] = useState(false);
  const [editingProjectId, setEditingProjectId] = useState(null);
  const [viewProjectModal, setViewProjectModal] = useState(false);
  const [viewProject, setViewProject] = useState(null);
  const [mileStoneModal, setMilestoneModal] = useState(false);
  const [milestoneProjectId, setMileProjectId] = useState(null);
  const [ticketViewOpen, setTicketViewOpen] = useState(false);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [isTicketFetching, setIsTicketFetching] = useState(false);
  const [isTicketLoading, setIsTicketLoading] = useState(false);
  const [milestoneViewPopup, setMilestoneViewPopup] = useState(false);
  const [milestoneViewId, setMileStoneViewId] = useState(null);
  const [editingMiletone, setMileStoneEditing] = useState(null);
  const [selectedProjectName, setSelectedProjectName] = useState(null);

  const [dropdownRefs] = useState({
    status: useRef(null),
    startDate: useRef(null),
    endDate: useRef(null),
  });

  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [nextProjectsUrl, setNextProjectsUrl] = useState(null);
  const projectsSidebarRef = useRef(null);

  // Add new state for editing ticket
  const [editingTicket, setEditingTicket] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnModalRef.current &&
        !columnModalRef.current.contains(event.target)
      ) {
        setColumTitle("");
        setColumnModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popUpRef.current && !popUpRef.current.contains(event.target)) {
        setOpenedId(null);
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check status dropdown
      if (
        dropdownRefs.status.current &&
        !dropdownRefs.status.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }

      // Check start date dropdown
      if (
        dropdownRefs.startDate.current &&
        !dropdownRefs.startDate.current.contains(event.target)
      ) {
        setStartDateDropdown(false);
      }

      // Check end date dropdown
      if (
        dropdownRefs.endDate.current &&
        !dropdownRefs.endDate.current.contains(event.target)
      ) {
        setEndDateDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const options = [
    { label: "canceled", icon: <FcCancel className="w-4 h-4 mr-2" /> },
    { label: "paused", icon: <FaPause className="w-4 h-4 mr-2" /> },
    { label: "in-progress", icon: <FaTasks className="w-4 h-4 mr-2" /> },
    { label: "completed", icon: <FaCheckCircle className="w-4 h-4 mr-2" /> },
  ];

  const viewOptions = [
    { id: "kanban", label: "Boards", icon: <PiKanban size={20} /> },
    { id: "list", label: "List View", icon: <MdOutlineViewList size={20} /> },
    { id: "grid", label: "Grid View", icon: <BsGrid3X3Gap size={18} /> },
  ];

  const handleSubmit = async (e) => {
    if (
      !projectData.title ||
      !projectData.description ||
      !projectData.startDate
    ) {
      dispatch(addToast({ message: "Please fill all fields", type: "error" }));
      return;
    }
    setCreating(true);

    if (isEditing) {
      handleUpdateProject();
      return;
    }

    try {
      const formdata = new FormData();
      formdata.append("title", projectData.title);
      formdata.append("description", projectData.description);
      formdata.append("start_date", projectData.startDate);
      formdata.append("end_date", projectData.endDate);
      //  formdata.append("url", projectData.url);
      formdata.append("budget", projectData.budget);
      formdata.append("status", selectedOption);
      formdata.append("company", userInfo?.company?.id);
      formdata.append("is_active", true);
      const res = await fetchApi.post("/projects/", formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 201) {
        updateProjects();
        setShowModal(false);
        dispatch(
          addToast({ message: "Project created successfully", type: "success" })
        );
        setProjectData({
          title: "",
          description: "",
          startDate: new Date(),
          endDate: "",
          url: "",
          budget: "",
        });
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    } finally {
      setCreating(false);
    }
  };

  const handleUpdateProject = async () => {
    try {
      const formdata = new FormData();
      formdata.append("title", projectData.title);
      formdata.append("description", projectData.description);
      formdata.append("start_date", projectData.startDate);
      formdata.append("end_date", projectData.endDate);
      formdata.append("budget", projectData.budget);
      formdata.append("status", selectedOption);

      const res = await fetchApi.patch(
        `/projects/${editingProjectId}/`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );

      if (res.status === 200) {
        updateProjects();
        setShowModal(false);
        dispatch(
          addToast({ message: "Project updated successfully", type: "success" })
        );
        resetForm();
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    } finally {
      setCreating(false);
    }
  };

  const resetForm = () => {
    setProjectData({
      title: "",
      description: "",
      startDate: "",
      endDate: "",
      url: "",
      budget: "",
    });
    setSelectedOption("in-progress");
    setIsEditing(false);
    setEditingProjectId(null);
  };

  const handleEditProject = (project) => {
    setIsOpen(false);
    setOpenedId(null);
    setIsEditing(true);
    setEditingProjectId(project.id);

    setProjectData({
      title: project.title,
      description: project.description,
      startDate: project.start_date,
      endDate: project.end_date || "",
      url: project.url || "",
      budget: project.total_budget ? project.total_budget.toString() : "",
    });

    setSelectedOption(project.status);
    setShowModal(true);
  };

  const handleCreate = (column) => {
    setTicketModal(true);
    setNewTocketColumnId(column);
  };

  const moveCard = (id, newStatus) => {
    setTickets((prev) =>
      prev.map((ticket) =>
        ticket.id === id
          ? {
              ...ticket,
              ticket_status: { ...ticket.ticket_status, id: newStatus },
            }
          : ticket
      )
    );
    handleUpdateCard(id, newStatus);
  };

  const handleUpdateCard = async (id, status) => {
    try {
      const res = await fetchApi.patch(
        `project-tickets/${id}/`,
        { ticket_status: status },
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
      if (res.status === 200) {
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }
  };

  const getProjects = async () => {
    setLoading(true);
    try {
      const res = await fetchApi.get(`projects/`, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 200) {
        setProjects(res.data.results);
        setNextProjectsUrl(res.data.next);
        if (!firstProjectId && res.data.results.length > 0) {
          getTickets(res.data.results[0].id);
          setOpenedProject(res.data.results[0].id);
          localStorage.setItem("firstProjectId", res.data.results[0].id);
        } else if (firstProjectId) {
          getTickets(firstProjectId);
          setOpenedProject(firstProjectId);
        }
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    } finally {
      setLoading(false);
    }
  };

  const handleProjectsScroll = async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const scrollThreshold = 50; // pixels from bottom to trigger load

    if (
      scrollHeight - (scrollTop + clientHeight) < scrollThreshold &&
      nextProjectsUrl &&
      !isLoadingMore
    ) {
      await fetchNextProjects();
    }
  };

  const fetchNextProjects = async () => {
    if (!nextProjectsUrl || isLoadingMore) return;

    setIsLoadingMore(true);
    try {
      const res = await fetchApi.get(nextProjectsUrl, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 200) {
        setProjects((prev) => [...prev, ...res.data.results]);
        setNextProjectsUrl(res.data.next);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    } finally {
      setIsLoadingMore(false);
    }
  };

  const updateProjects = async () => {
    try {
      const res = await fetchApi.get("projects/", {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 200) {
        setProjects(res.data.results);
        setOpenedProject(res.data.results[0].id);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }
  };

  const createLoadingTickets = (columns) => {
    // Create one loading ticket for each column
    return columns.map((column) => ({
      id: `loading-${column.id}`,
      title: "Loading...",
      description: "Loading ticket content...",
      priority: "medium",
      type: "task",
      started_at: new Date().toISOString(),
      time_allotted: "0",
      developer: null,
      ticket_status: { id: column.id },
      attachment: [],
    }));
  };

  const getTickets = async (id) => {
    setTicketsLoading(true);
    // Create loading tickets for each column
    const loadingTickets = columns.map((column) => ({
      id: `loading-${column.id}`,
      title: "Loading...",
      description: "Loading ticket content...",
      priority: "medium",
      type: "task",
      started_at: new Date().toISOString(),
      time_allotted: "0",
      developer: null,
      ticket_status: { id: column.id },
      attachment: [],
    }));

    // Set loading state
    setTickets(loadingTickets);

    try {
      const res = await fetchApi.post(
        `get-project-tickets/`,
        { project_id: id },
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
      if (res.status === 200) {
        setTickets(res.data);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
      setTickets([]); // Clear tickets on error
    } finally {
      setTicketsLoading(false);
    }
  };

  let projectFetched = useRef(false);
  useEffect(() => {
    if (userInfo?.user?.role?.name === "Time Reporter") {
      // For Time Reporter, directly set their assigned project and fetch tickets
      if (userInfo?.user?.project) {
        // Map the project data to match expected structure
        const formattedProject = {
          id: userInfo.user.project.id,
          title: userInfo.user.project.name,
          total_milestone: userInfo.user.project.milestone_count,
          milesron_completed: userInfo.user.project.completed_milestone_count,
          project_progress: userInfo.user.project.progress,
          start_date: new Date().toISOString().split('T')[0], // Default to today if not provided
          first_two_users: [], // Empty array if no users provided
          total_user_of_project: 0 // Default to 0 if not provided
        };
        setProjects([formattedProject]);
        setOpenedProject(formattedProject.id);
        getTickets(formattedProject.id);
      }
    } else {
      // For other roles, fetch all projects if not already fetched
      if (projectFetched.current) return;
      projectFetched.current = true;
      getProjects();
      if (firstProjectId) {
        getTickets(firstProjectId);
      }
    }
  }, [userInfo]);

  const getCompanyColums = async () => {
    try {
      const query = userInfo?.user?.role?.name !== 'Time Reporter' 
        ? `company=${userInfo.company.id}`
        : `company__owner__domain=${userInfo.user.domain}`;
   
      const res = await fetchApi.get(
      `company-board-columns/?search=bugdev`,
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
      if (res.status === 200) {
        const data = res.data.results.sort((a, b) => a.order - b.order);
        setColumns(data);
      }
    } catch (e) {
      dispatch(addToast({ message: "Something went wrong", type: "error" }));
    }
  };
  

  const handleColumCreate = async () => {
    setCreating(true);
    let columorder = columns.length;

    if (isEditingColumn) {
      try {
        const res = await fetchApi.patch(
          `company-board-columns/${editingColumnId}/`,
          {
            title: columTitle,
          },
          {
            headers: {
              Authorization: `Bearer ${userInfo.access_token}`,
            },
          }
        );
        if (res.status === 200) {
          setColumns((prev) =>
            prev.map((col) =>
              col.id === editingColumnId ? { ...col, title: columTitle } : col
            )
          );
          dispatch(addToast({ message: "Column updated", type: "success" }));
          setColumnModal(false);
          setColumTitle("");
          setIsEditingColumn(false);
          setEditingColumnId(null);
        }
      } catch (error) {
        dispatch(addToast({ message: "Something went wrong", type: "error" }));
      } finally {
        setCreating(false);
      }
      return;
    }

    try {
      const res = await fetchApi.post(
        "company-board-columns/",
        {
          company: userInfo.company.id,
          title: columTitle,
          order: columorder,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
      if (res.status === 201) {
        setColumns((prev) => [...prev, res.data]);
        dispatch(addToast({ message: "Column created", type: "success" }));
        setColumnModal(false);
      }
    } catch (eror) {
      dispatch(addToast({ message: "Something went wrong", type: "error" }));
    } finally {
      setCreating(false);
    }
  };

  const handleEditColumn = (column) => {
    setIsEditingColumn(true);
    setEditingColumnId(column.id);
    setColumTitle(column.title);
    setColumnModal(true);
  };

  useEffect(() => {
    getCompanyColums();
  }, []);

  const moveColumn = (fromIndex, toIndex, columnId) => {
    setColumns((prevColumns) => {
      const updatedColumns = [...prevColumns];
      const [movedColumn] = updatedColumns.splice(fromIndex, 1); // Remove the column
      updatedColumns.splice(toIndex, 0, movedColumn); // Insert at new position
      return updatedColumns;
    });
  };
  const handleUpdateColumePosition = async (columnId, order) => {
    try {
      const res = await fetchApi.patch(
        `company-board-columns/${columnId}/`,
        { order: order },
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
    } catch (error) {}
  };

  const handleDeleteProject = async (item) => {
    setIsOpen(false);
    setOpenedId(null);
    try {
      const res = await fetchApi.delete(`projects/${item.id}/`, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 204) {
        dispatch(
          addToast({ message: "Project deleted successfully", type: "success" })
        );
        setProjects((prev) => prev.filter((project) => project.id !== item.id));
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    } finally {
    }
  };

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isModalOpen]);

  const handleTicketClick = async (id) => {
    setTicketViewOpen(true);
    fetchTicketsDetail(id);
  };

  const fetchTicketsDetail = async (id) => {
    setIsTicketFetching(true);
    try {
      const res = await fetchApi.get(`project-tickets/${id}/`, {
        headers: { Authorization: `Bearer ${userInfo.access_token}` },
      });
      if (res.status === 200) {
        const result = res.data;
        setTicketDetails(result);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    } finally {
      setIsTicketFetching(false);
    }
  };

  // Add function to handle ticket update
  const handleUpdateTicket = async (updatedData) => {
    try {
      const res = await fetchApi.patch(
        `project-tickets/${editingTicket.id}/`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );

      if (res.status === 200) {
        dispatch(
          addToast({ message: "Ticket updated successfully", type: "success" })
        );
        setTicketModal(false);
        setEditingTicket(null);
        // Refresh tickets
        getTickets(openedProject);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }
  };

  const handleEditTicket = (ticketData) => {
    setTicketViewOpen(false);
    setEditingTicket(ticketData);
    setTicketModal(true);
  };


  function countCompletedMilestones(projectData) {
    if (!projectData.milestones || !Array.isArray(projectData.milestones)) {
        return 0;
    }
    
    return projectData.milestones.filter(milestone => 
        milestone.status === 'completed'
    ).length;
}

function calculateProjectProgress(projectData) {
    if (!projectData.milestones || !Array.isArray(projectData.milestones)) {
        return 0;
    }
    
    const totalMilestones = projectData.milestones.length;
    if (totalMilestones === 0) {
        return 0;
    }
    
    const completedMilestones = countCompletedMilestones(projectData);
    return Math.round((completedMilestones / totalMilestones) * 100);
}


  return (
    <DndProvider backend={HTML5Backend}>
      <div className="w-full customFont">
        <div
          className={` ${
            theme === "dark" ? "text-white" : "text-black"
          } md:px px-4 py-6 flex w-full justify-between items-center capitalize `}
        >
          <span
            style={{
              fontSize: "x-large",
            }}
          >
            {selectedProjectName ? selectedProjectName :'Projects'}
          </span>
          <div className="flex gap-2 items-center">
            {userInfo?.user?.role?.name !== "Time Reporter" && (
              <button
                className={`heroButton  w-full`}
                onClick={() => setShowModal(true)}
              >
                Create Project
              </button>
            )}
            <div
              className={`relative flex items-center px-1 py-1 rounded-full w-fit border 
              ${
                theme === "dark"
                  ? "border-gray-600 bg-transparent"
                  : "border-gray-300 bg-white"
              }`}
            >
              <motion.div
                className="absolute top-1 left-1 h-[calc(100%-8px)] rounded-full bg-gradient-to-r from-[#CC0927] to-[#7E0105]"
                animate={{
                  x: `${
                    selected === "kanban" ? 0 : selected === "list" ? 45 : 87
                  }px`,
                  width:
                    selected === "kanban"
                      ? 100
                      : selected === "list"
                      ? 110
                      : 120,
                }}
                transition={{ type: "spring", stiffness: 200, damping: 20 }}
              />

              {viewOptions.map((option, index) => (
                <button
                  key={option.id}
                  onClick={() => setSelected(option.id)}
                  className={`relative flex items-center gap-2 px-3 py-2 outline-none z-10 transition-all duration-200 
        ${selected === option.id ? "text-white font-medium" : "text-gray-600"}`}
                >
                  {option.icon}
                  {selected === option.id && (
                    <span className="whitespace-nowrap">{option.label}</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
        <hr className="w-full" />
        {loading && (
          <>
            <div
              className="fixed inset-0 bg-black bg-opacity-50 z-[50]"
              style={{ top: "95px" }}
            ></div>
            <div
              className="fixed inset-0 flex items-center justify-center z-[60]"
              style={{ top: "95px" }}
            >
              <Loader />
            </div>
          </>
        )}
        <div
          className={`w-full flex md:flex-row flex-col  md:px-4 px-2 py-2 relative ${
            projectSideBarOpen ? " gap-7" : "gap-2"
          }`}
        >
            <div
                className={`absolute top-3 shadow-2xl left-0 z-10 p-1 rounded-r-md cursor-pointer mb-2  w-max ${
                  theme === "dark"
                    ? " bg-[#212529] text-white"
                    : "bg-gray-100 text-black"
                }`}
              >
                {projectSideBarOpen ? (
                  <FaAngleLeft
                    className="w-6 h-6 cursor-pointer"
                    onClick={() => setProjectSideBarOpen(false)} // Close sidebar
                  />
                ) : (
                  <FaAngleRight
                    className="w-6 h-6 cursor-pointer"
                    onClick={() => setProjectSideBarOpen(true)} // Open sidebar
                  />
                )}
              </div>
          <div
            className={`  ${theme === "dark" ? "bg-[#1C1C1E] " : "bg-white"} ${
              projectSideBarOpen ? " relative w-max" : "relative w-8 "
            }`}
          >
            <div
              className={`${
                projectSideBarOpen ? " w-full flex justify-end" : "w-max "
              }`}
            >
            </div>
            <div
              ref={projectsSidebarRef}
              className={`relative h-full md:max-h-[82vh] max-h-[40vh] overflow-y-auto pr-1 py-2 ${
                projectSideBarOpen
                  ? "translate-x-0 left-[16px]"
                  : "-translate-x-full left-[-30px]"
              } transition-transform duration-300 ease-in-out z-30 bg-transparent`}
              onScroll={handleProjectsScroll}
            >
              {projects?.length > 0 ? (
                projects?.map((project) => (
                  <div
                    key={project.id}
                    className={`p-2 pb-3 mb-2 rounded-[16px] shadow-md w-[275px] cursor-pointer ${
                      openedProject === project.id
                        ? theme === "dark"
                          ? "bg-[#1f1f1f] text-white"
                          : "bg-[#D8D8D8] text-black"
                        : theme === "dark"
                        ? "text-white bg-darkMode"
                        : "text-black bg-slate-50"
                    } ${
                      theme === "dark"
                        ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                        : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                    } ${openedProject}`}
                    onClick={() => {
                      getTickets(project.id);
                      setOpenedProject(project.id);
                      setSelectedProjectName(project?.title);
                    }} 
                  >
                    <div className="flex gap-2 items-center justify-between">
                      <span className="text-lg font-medium">
                        {project.title}
                      </span>
                      <div className="relative">
                        <BsThreeDotsVertical
                          className="w-5 h-5 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation(); // Stop event from bubbling up
                            if (
                              userInfo?.user?.role?.name === "Time Reporter"
                            ) {
                              dispatch(
                                addToast({
                                  message:
                                    "You do not have permission to edit project",
                                  type: "warn",
                                })
                              );
                              return;
                            }
                            setOpenedId(project?.id);
                            setIsOpen(true);
                          }}
                        />
                        {openedId === project?.id && (
                          <div
                            className={`absolute right-0 mt-2 w-40 z-10 rounded-[10px] shadow-lg border overflow-hidden
                                            ${
                                              theme === "dark"
                                                ? "bg-[#212529] border-[#555657]"
                                                : "bg-[#F2F4F7] border-[#9A9F9A]"
                                            }`}
                            ref={popUpRef}
                            onClick={(e) => e.stopPropagation()} // Stop event from bubbling up
                          >
                            <button
                              className={`w-full text-left px-4 py-2 text-base flex items-center font-medium gap-1 outline-none border-none ${
                                theme === "dark"
                                  ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all text-white"
                                  : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all text-black"
                              }`}
                              onClick={(e) => {
                                e.stopPropagation(); // Stop event from bubbling up
                                handleEditProject(project);
                              }}
                            >
                              <FaRegEdit className="w-5 h-5" />
                              Edit
                            </button>
                            <button
                              className={`w-full text-left px-4 py-2 text-base flex items-center font-medium gap-1 outline-none border-none ${
                                theme === "dark"
                                  ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all text-white"
                                  : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all text-black"
                              }`}
                              onClick={(e) => {
                                e.stopPropagation(); // Stop event from bubbling up
                                setOpenedId(null);
                                setIsOpen(false);
                                setViewProjectModal(true);
                                setViewProject(project);
                              }}
                            >
                              <MdPreview className="w-5 h-5" />
                              View
                            </button>
                            <button
                              className={`w-full text-left px-4 py-2 text-base flex gap-1 items-center font-medium text-red-500 border-none ${
                                theme === "dark"
                                  ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                                  : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                              }`}
                              onClick={(e) => {
                                e.stopPropagation(); // Stop event from bubbling up
                                handleDeleteProject(project);
                              }}
                            >
                              <RiDeleteBin6Line className="w-5 h-5" />
                              Delete Project
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="w-full cursor-pointer">
                      <div className="flex w-full justify-between items-center mt-1">
                        <div className="flex gap-2 mt-1 items-center">
                          <IoCalendarClearOutline className="w-4 h-4 " />
                          <span className="text-sm ">{project.start_date}</span>
                        </div>
                        <div className="flex items-center gap-1 text-base">
                          <FaRegCheckCircle className="w-4 h-4" />
                          {countCompletedMilestones(project) || 0}/
                          {project?.milestones?.length || 0}
                        </div>
                      </div>
                      <div className="w-full">
                        <div
                          className={`w-full h-2 rounded-full mt-2 ${
                            theme === "dark" ? "bg-gray-300" : "bg-[#9A9FA5]"
                          }`}
                        >
                          <div
                            className="h-full bg-gradient-to-r from-[#CC0927] to-[#7E0105] rounded-full"
                            style={{
                              width:
                                Math.floor(calculateProjectProgress(project)) + "%",
                            }}
                          ></div>
                        </div>
                        <div className="w-full text-right text-gray-500 text-xs">
                          {Math.floor(calculateProjectProgress(project)) || 0} %
                        </div>
                      </div>

                      <div className="flex items-center space-x-[-10px] mt-[-10px]">
                        {project?.first_two_users?.map((user, index) =>
                          user?.picture ? (
                            <img
                              key={user.id}
                              src={user.picture}
                              alt={`User ${index + 1}`}
                              className="w-6 h-6 rounded-full border-2 border-white object-cover"
                            />
                          ) : (
                            <FaUserCircle className="w-6 h-6 rounded-full border-2 border-white object-cover text-gray-500" />
                          )
                        )}

                        {project?.total_user_of_project -
                          project?.first_two_users.length >
                          0 && (
                          <div className="w-8 h-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-lg  font-medium">
                            +
                            {project?.total_user_of_project -
                              project?.first_two_users.length}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-gray-500 text-base font-normal py-4 px-2 w-[275px]">
                  There is no project yet
                </div>
              )}

              {isLoadingMore && (
                <div className="flex justify-center p-2">
                  <img
                    src={loader}
                    alt="Loading more projects..."
                    className="w-6 h-6"
                  />
                </div>
              )}

              {!nextProjectsUrl && projects.length > 0 && (
                <div className="text-center p-2 text-sm text-gray-400">
                  No more projects to load
                </div>
              )}
            </div>
          </div>
          <div
            className={`cards_container overflow-x-scroll flex gap-4 w-full mt-6 pb-3 min-h-[65vh]`}
            style={{ minWidth: "75%" }}
            onDragOver={(e) => {
              e.preventDefault();

              const container = e.currentTarget;
              const scrollSpeed = 5;
              const { left, right } = container.getBoundingClientRect();

              if (e.clientX < left + 50) {
                if (!container.scrollInterval) {
                  container.scrollInterval = setInterval(() => {
                    container.scrollBy({ left: -scrollSpeed });
                  }, 10);
                }
              } else if (e.clientX > right - 50) {
                if (!container.scrollInterval) {
                  container.scrollInterval = setInterval(() => {
                    container.scrollBy({ left: scrollSpeed });
                  }, 10);
                }
              } else {
                clearInterval(container.scrollInterval);
                container.scrollInterval = null;
              }
            }}
            onDragLeave={(e) => {
              const container = e.currentTarget;
              clearInterval(container.scrollInterval);
              container.scrollInterval = null;
            }}
            onDrop={(e) => {
              const container = e.currentTarget;
              clearInterval(container.scrollInterval);
              container.scrollInterval = null;
            }}
          >
            {loading ? (
              <div className="w-full h-full flex items-center justify-center"></div>
            ) : (
              <div className="flex gap-[10px]">
                {columns?.map((column, index) => (
                  <DropZone
                    key={column.id}
                    index={index}
                    column={column}
                    tickets={tickets?.filter(
                      (ticket) => ticket?.ticket_status?.id === column.id
                    )}
                    setTickets={setTickets}
                    ticketsLoading={ticketsLoading}
                    moveCard={moveCard}
                    moveColumn={moveColumn}
                    theme={theme}
                    handleCreate={handleCreate}
                    setDraggingColumn={setDraggingColumn}
                    draggingColumn={draggingColumn}
                    handleUpdateColumePosition={handleUpdateColumePosition}
                    columns={columns}
                    setColumns={setColumns}
                    handleTicketClick={handleTicketClick}
                    handleEditColumn={handleEditColumn}
                    handleEditTicket={handleEditTicket}
                    isTicketLoading={isTicketLoading}
                    setIsTicketLoading={setIsTicketLoading}
                    setTicketModal={setTicketModal}
                  />
                ))}
              </div>
            )}
          </div>
          {userInfo.user.role.name === "Admin" && (
            <button
              className={`absolute top-3 shadow-lg right-0 z-10 py-1 px-2 text-4xl text-red-600 font-bold rounded-l-md ${
                theme === "dark" ? "bg-darkMode " : "bg-white "
              }`}
              onClick={() => setColumnModal(true)}
            >
              <IoMdAdd className="cursor-pointer w-7 h-7 text-red-600" />
            </button>
          )}
        </div>
        {isModalOpen && (
          <>
            {/* Overlay */}
            <div className="fixed inset-0 bg-black bg-opacity-50 z-[1000] "></div>
            <div className="w-full h-full max-h-[100vh] overflow-y-scroll z-[1010] inset-0 fixed px-4 py-4 ">
              {/* Modal Content */}
              <div className="flex min-h-full items-center justify-center">
                <div className=" flex items-center justify-center w-full ">
                  <div
                    className={` p-6 rounded-[20px] shadow-lg max-w-[640px]  w-full ${
                      theme === "dark"
                        ? "bg-darkMode text-white"
                        : "bg-white text-black"
                    }`}
                  >
                    <div className="flex justify-between">
                      <div className="flex gap-2 items-center">
                        <div
                          className={`p-1 rounded-full ${
                            theme === "dark"
                              ? " bg-gray-700 text-white"
                              : "bg-gray-300 text-black"
                          }`}
                        >
                          <IoIosArrowForward className="w-5 h-5" />
                        </div>
                        <h2 className="text-xl font-semibold">
                          {isEditing ? "Edit Project" : "New Project"}
                        </h2>
                      </div>
                      <div
                        className={`p-1 rounded-full ${
                          theme === "dark"
                            ? " bg-gray-700 text-white"
                            : "bg-gray-300 text-black"
                        }`}
                      >
                        <IoClose
                          className="w-6 h-6"
                          onClick={() => {
                            setShowModal(false);
                            resetForm();
                          }}
                        />
                      </div>
                    </div>
                    <hr
                      className={`mt-4 ${
                        theme === "dark" ? "text-white" : "text-black"
                      }`}
                    />
                    <div className="flex gap-1 flex-col mt-6">
                      <label
                        htmlFor=""
                        className="font-semibold flex items-center gap-1 text-lg"
                      >
                        <FaRegEdit className="w-5 h-5" />
                        Title <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        className={`text-base font-normal mt-1 p-2 bg-transparent outline-none w-full rounded-[10px] border ${
                          theme === "dark"
                            ? "placeholder:text-gray-600 border-gray-600 "
                            : "placeholder:text-gray-400 border-[#555657]"
                        }`}
                        value={projectData.title}
                        onChange={(e) =>
                          setProjectData({
                            ...projectData,
                            title: e.target.value,
                          })
                        }
                        placeholder="Enter title of project"
                      />
                    </div>
                    <div className="w-full grid grid-cols-2 gap-2 mt-4">
                      <div className="">
                        <label
                          htmlFor=""
                          className="font-semibold  flex items-center gap-1 text-lg"
                        >
                          <BiSolidDollarCircle className="w-5 h-5" />
                          Budget <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="text"
                          className={`text-base font-normal border bg-transparent p-2 outline-none mt-1 w-full rounded-[10px] ${
                            theme === "dark"
                              ? "placeholder:text-gray-600 border-gray-600 "
                              : "placeholder:text-gray-400 border-[#555657] "
                          }`}
                          value={projectData.budget}
                          onChange={(e) =>
                            setProjectData({
                              ...projectData,
                              budget: e.target.value,
                            })
                          }
                          placeholder="Budget of project"
                        />
                      </div>
                      <div className="">
                        <label
                          htmlFor="status "
                          className="text-lg flex items-center gap-1 "
                        >
                          <FaClipboardList className="w-5 h-5" />
                          Status:
                        </label>
                        <div
                          ref={dropdownRefs.status}
                          className={`relative flex items-center justify-between border rounded-[10px] px-2 py-2 mt-1 cursor-pointer w-full  ${
                            theme === "dark"
                              ? "border-gray-600"
                              : "border-[#555657]"
                          }`}
                          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        >
                          <div className="flex items-center">
                            {
                              options.find(
                                (option) => option.label === selectedOption
                              )?.icon
                            }
                            <span className=" capitalize">
                              {selectedOption}
                            </span>
                          </div>
                          {isDropdownOpen ? (
                            <FaChevronUp className="w-4 h-4 " />
                          ) : (
                            <FaChevronDown className="w-4 h-4" />
                          )}
                          {isDropdownOpen && (
                            <div
                              className={`absolute top-full left-0 mt-2 w-44 shadow-lg rounded-md z-10 ${
                                theme === "dark"
                                  ? "bg-dashboardDarkMode text-white"
                                  : "bg-lightMode text-black"
                              }`}
                            >
                              {options.map((option) => (
                                <div
                                  key={option.label}
                                  className={`flex items-center px-3 py-2 hover:bg-gray-200 cursor-pointer ${
                                    theme === "dark" ? "hover:bg-gray-700" : ""
                                  }`}
                                  onClick={() => {
                                    setSelectedOption(option.label);
                                    setIsDropdownOpen(false);
                                  }}
                                >
                                  {option.icon}
                                  <span className="capitalize">
                                    {option.label}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid items-center grid-cols-2 mt-4 gap-2">
                      <div className="flex gap-1 flex-col">
                        <label
                          htmlFor=""
                          className="font-semibold flex items-center gap-1 text-lg"
                        >
                          <FaCalendarAlt className="w-5 h-5" />
                          Start Date <span className="text-red-600">*</span>
                        </label>
                        <div
                          ref={dropdownRefs.startDate}
                          className={`cursor-pointer relative bg-transparent w-full flex justify-between items-center outline-none border px-2 py-2 rounded-[10px] mt-1 ${
                            theme === "dark"
                              ? "border-gray-600 "
                              : "border-[#555657]"
                          }`}
                        >
                          <span
                            className="w-full flex items-center justify-between"
                            onClick={() => {
                              setStartDateDropdown(!startDateDropdown);
                              setEndDateDropdown(false);
                            }}
                          >
                            {projectData.startDate.length > 0
                              ? projectData.startDate
                              : "Choose date"}{" "}
                            <button>
                              {startDateDropdown ? (
                                <FaChevronUp className="w-4 h-4 " />
                              ) : (
                                <FaChevronDown className="w-4 h-4" />
                              )}
                            </button>
                          </span>
                          {startDateDropdown && (
                            <Calendar
                              theme={theme}
                              onDateSelect={(date) => {
                                projectData.startDate = date;
                                setStartDateDropdown(false);
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="flex gap-1 flex-col">
                        <label
                          htmlFor=""
                          className="font-semibold flex items-center gap-1 text-lg"
                        >
                          <FaCalendarAlt className="w-5 h-5" />
                          End Date<span className="text-red-600">*</span>
                        </label>
                        <div
                          ref={dropdownRefs.endDate}
                          className={`relative cursor-pointer bg-transparent w-full outline-none border px-2 py-2 rounded-[10px] mt-1 ${
                            theme === "dark"
                              ? "border-gray-600 "
                              : "border-[#555657]"
                          }`}
                        >
                          <span
                            className="w-full flex items-center justify-between"
                            onClick={() => {
                              setEndDateDropdown(!endDateDropdown);
                              setStartDateDropdown(false);
                            }}
                          >
                            {projectData.endDate.length > 0
                              ? projectData.endDate
                              : "Choose date"}{" "}
                            <button>
                              {endDateDropdown ? (
                                <FaChevronUp className="w-4 h-4 " />
                              ) : (
                                <FaChevronDown className="w-4 h-4" />
                              )}
                            </button>
                          </span>
                          {endDateDropdown && (
                            <Calendar
                              theme={theme}
                              onDateSelect={(date) => {
                                projectData.endDate = date;
                                setEndDateDropdown(false);
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    {isEditing && (
                      <div className="flex gap-1 flex-col mt-4">
                        <button
                          className="mt-1 heroButton font-medium w-max "
                          onClick={() => {
                            setMileProjectId(openedProject);
                            setMilestoneModal(true);
                          }}
                        >
                          Add Milestone
                        </button>
                      </div>
                    )}
                    <label htmlFor="" className="font-semibold mt-4 text-lg">
                      Description
                    </label>

                    <RichTextEditor1
                      setProjectData={setProjectData}
                      projectData={projectData}
                    />
                    <div className="flex gap-2 justify-end pt-4">
                      <button
                        className={` border rounded-3xl px-6 py-2 bg-transparent  ${
                          theme === "dark"
                            ? "border-gray-600"
                            : "border-gray-600"
                        }`}
                        onClick={() => {
                          setShowModal(false);
                          resetForm();
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="heroButton"
                        disabled={creating}
                        onClick={handleSubmit}
                        style={{ paddingLeft: "24px", paddingRight: "24px" }}
                      >
                        {creating
                          ? isEditing
                            ? "Updating..."
                            : "Creating..."
                          : isEditing
                          ? "Update"
                          : "Create"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {columnModal && (
          <>
            {/* Overlay */}
            <div className="fixed inset-0 bg-black bg-opacity-50 z-[50]"></div>

            {/* Modal Content */}
            <div className="fixed inset-0 flex items-center justify-center z-[60] ">
              <div
                className={` p-6 rounded-[20px] shadow-lg max-w-md w-full max-h-[80vh] overflow-auto ${
                  theme === "dark"
                    ? "bg-darkMode text-white"
                    : "bg-lightMode text-black"
                }`}
                ref={columnModalRef}
              >
                <div className="flex justify-between w-full text-center">
                  <div className="flex gap-2 items-center w-full justify-center">
                    <h2 className="text-lg font-semibold">
                      {isEditingColumn ? "Edit Column" : "New Column"}
                    </h2>
                  </div>
                  <div
                    className={`p-1 rounded-full ${
                      theme === "dark"
                        ? " bg-gray-700 text-white"
                        : "bg-gray-300 text-black"
                    }`}
                  >
                    <IoClose
                      className="w-6 h-6"
                      onClick={() => {
                        setColumnModal(false);
                        setColumTitle("");
                        setIsEditingColumn(false);
                        setEditingColumnId(null);
                      }}
                    />
                  </div>
                </div>
                <hr
                  className={`mt-6 border-t-2 ${
                    theme === "dark" ? "border-gray-600" : "border-gray-400"
                  }`}
                />
                <label
                  htmlFor=""
                  className="font-semibold mt-4 text-lg flex items-center gap-1"
                >
                  Title <span className="text-xl text-red-600">*</span>
                </label>
                <input
                  type="text"
                  className={`text-base font-normal border rounded-[10px] mt-2 py-2 px-2 bg-transparent outline-none w-full ${
                    theme === "dark"
                      ? "placeholder:text-gray-600 border-gray-600 "
                      : "placeholder:text-gray-400 border-[#555657] "
                  }`}
                  value={columTitle}
                  onChange={(e) => setColumTitle(e.target.value)}
                  placeholder="Enter title of column"
                />

                <button
                  className="heroButton mt-6 w-full font-medium "
                  disabled={creating}
                  onClick={handleColumCreate}
                >
                  {creating
                    ? isEditingColumn
                      ? "Updating..."
                      : "Creating..."
                    : isEditingColumn
                    ? "Update"
                    : "Create"}
                </button>
              </div>
            </div>
          </>
        )}
        {ticketModal && (
          <TicketModal
            setTicketModal={setTicketModal}
            newTicketColumnId={newTicketColumnId}
            ticketStatus={newTicketStatus}
            openedProject={openedProject}
            updateTickets={getTickets}
            setTickets={setTickets}
            editingTicket={editingTicket}
            handleUpdateTicket={handleUpdateTicket}
            setEditingTickt={setEditingTicket}
            isTicketLoading={isTicketLoading}
            getTickets={getTickets}
          />
        )}
        {viewProjectModal && (
          <ViewProject
            project={viewProject}
            onClose={setViewProjectModal}
            editProject={handleEditProject}
            deleteProject={handleDeleteProject}
            setMileStoneId={setMileStoneViewId}
            setViewMileStonePopup={setMilestoneViewPopup}
          />
        )}

        {mileStoneModal && (
          <ProjectDetail
            setOpen={setMilestoneModal}
            projectId={milestoneProjectId}
            editingMiletone={editingMiletone}
            setEditingMileStone={setMileStoneEditing}
          />
        )}
        {ticketViewOpen && (
          <TicketView
            handleClose={() => {
              setTicketViewOpen(false);
              setTicketDetails(null);
            }}
            ticketDetail={ticketDetails}
            isTicketFetching={isTicketFetching}
            setTicketDetails={setTicketDetails}
            handleEditTicket={handleEditTicket}
          />
        )}
        {milestoneViewPopup && (
          <MilestoneView
            mileStoneId={milestoneViewId}
            setEditingMileStone={setMileStoneEditing}
            setMileStoneModalOpen={setMilestoneModal}
            setMilestoneView={setMilestoneViewPopup}
          />
        )}
      </div>
    </DndProvider>
  );
};

export default Board;
